import MaterialIcon from "@/common/MaterialIcon/MaterialIcon";

const ErrorMessage = ({
  wrapperClassName = "",
  errorClassName = "",
  error = null,
}) => {
  if (error)
    return (
      <div className={`errorMessage ${wrapperClassName}`}>
        <div
          className={`${errorClassName} d-flex flex-column justify-content-center error-message`}
          role="alert"
        >
          {error &&
            (Array.isArray(error?.data?.errors) ? (
              error?.data?.errors.map((e, index) => {
                return (
                  <div className="d-flex" key={index}>
                    <MaterialIcon iconName="error" wrapperClassName="mx-2" />
                    {e.errorCode ? `${e.errorCode} - ` : ""}
                    {e.errorMessage}
                  </div>
                );
              })
            ) : (
              <div className="d-flex">
                <MaterialIcon iconName="error" wrapperClassName="me-2" />
                {error.errorCode ? `${error.errorCode} - ` : ""}
                {error.errorMessage}
              </div>
            ))}
        </div>
      </div>
    );
};

export default ErrorMessage;
